export const COOKIE_NAME = "acceptCookie";
export const COOKIE_VALUE = "accepted";
export const COOKIE_EXPIRY_DATE = 365;